<template>
    <div class="page" v-if="isDataLoaded">
        <HeadKf></HeadKf>
        <div class="search">
            <van-search show-action v-model="searchForm.kw" placeholder="请输入报障单编号或者订单编号" @search="getOrder"
                @clear="getOrder">
                <template #action>
                    <div @click="getOrder">搜索</div>
                </template>
            </van-search>
        </div>
        <div class="tabs" data-flex="">
            <div class="tabs-list" v-for="item in filterTypes" :key="item.id" data-flex-box="0"
                data-flex="dir:top main:center cross:center" @click="changeFilterType($event, item.id)">
                <span data-flex-box="0" :class="{ cur: searchForm.filterType == item.id }">{{ item.text }}</span>
                <div v-if="searchForm.filterType == item.id"></div>
            </div>
        </div>

        <!-- <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="item in list" :key="item" :title="item" />
        </van-list> -->
        <div class="item" v-if="!isEmpty(list)">
            <div class="bd1" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
                <div class="sc-item">
                    <div class="header" data-flex-box="0" data-flex="cross:center">
                        <p data-flex-box="1" class="f-fc1 f-fwb f-fs14">订单编号：{{ item.orderNo }}</p>
                        <p class="f-fs14 f-fc6 ">
                            <template v-if="item.type == 1">上门服务</template>
                            <template v-else-if="item.type == 2">返厂维修</template>
                            <template v-else-if="item.type == 3">预约巡检</template>
                            <template v-else-if="item.type == 4">申请延保</template>
                            <template v-else-if="item.type == 5">直播申请</template>
                            <template v-else-if="item.type == 6">在线报障</template>
                            <template v-else-if="item.type == 7">预约培训</template>
                            <template v-else-if="item.type == 8">预约调试</template>
                            <template v-else-if="item.type == 9">业务咨询</template>
                        </p>
                    </div>
                    <div class="rb" data-flex-box="1" data-flex="dir:top main:justify">
                        <template v-if="item.type == 1 || item.type == 2 || item.type == 3">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">用户名称：</p>
                                <p class="txt1">{{ item.userName }}</p>
                            </div>
                        </template>
                        <template v-else-if="item.type == 4">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">服务需求：</p>
                                <p class="txt1">{{ item.fault }}</p>
                            </div>
                        </template>
                        <template v-else-if="item.type == 5">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">设备租赁：</p>
                                <p class="txt1">{{ item.isLease }}</p>
                            </div>
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">技术支撑：</p>
                                <p class="txt1">{{ item.fault }}</p>
                            </div>
                        </template>
                        <template v-else-if="item.type == 6">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">故障描述：</p>
                                <p class="txt1">{{ item.fault }}</p>
                            </div>

                        </template>
                        <template v-else-if="item.type == 7">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">培训内容：</p>
                                <p class="txt1">{{ item.fault }}</p>
                            </div>
                        </template>
                        <template v-else-if="item.type == 8">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">调试类型：</p>
                                <p class="txt1">{{ item.ywType }}</p>
                            </div>
                        </template>
                        <template v-else-if="item.type == 9">
                            <div class="list" data-flex="cross:center">
                                <p data-flex-box="0" class="tit f-fs14 f-fwb">业务类型：</p>
                                <p class="txt1">{{ item.ywType }}</p>
                            </div>
                        </template>
                        <div class="list" data-flex="cross:center">
                            <p data-flex-box="0" class="tit f-fs14 f-fwb">创建时间：</p>
                            <p class="txt1">{{ item.ctime }}</p>
                        </div>
                        <div class="list" data-flex="cross:center">
                            <p data-flex-box="0" class="tit f-fs14 f-fwb">工单状态：</p>
                            <p class="txt1 f-fc4">{{ item.isEvaluate == 1 ? '已评价' : item.processingStatus }}</p>
                        </div>
                    </div>
                </div>
                <div class="ops" data-flex="cross:center">
                    <span data-flex-box="1"></span>
                    <div class="s1" hover-class="none"
                        @click.stop="toLink('https://im7a2314e.7x24cc.com/fu_u2x7lgvmse')" data-flex-box="0">
                        问题反馈</div>
                    <div class="s2" hover-class="none" v-if="item.processingStatus == '已完成' && item.isEvaluate != 1"
                        @click.stop="funEvaluate(item.type, { orderId: item.id })" data-flex-box="0">
                        服务评价</div>
                    <div class="s3" hover-class="none" data-flex-box="0" @click.stop="toHome('/')">
                        重新下单</div>
                </div>
            </div>
        </div>
        <div v-else>
            <van-empty description="暂无" />
        </div>
        <Evaluate></Evaluate>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Tab, Tabs, Progress, Empty, Search, Cell, List } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import Evaluate from '@/components/common/evaluate'
import HeadKf from '@/components/common/head-kf'

export default {
    mixins: [mix1],
    components: {
        MgPopup,
        [Cell.name]: Cell,
        [List.name]: List,
        [Button.name]: Button,
        [Search.name]: Search,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Progress.name]: Progress,
        [Empty.name]: Empty,
        Evaluate,
        HeadKf
    },
    data() {
        return {
            filterTypes: [
                { id: -255, text: '全部' },
                { id: 1, text: '待服务' },
                { id: 2, text: '已完成' },
            ],
            showPivot: false,
            searchForm: {
                kw: '',
                filterType: -255,
                pageSize: 999
            },
            list: [],

            // list: [],
            // loading: false,
            // finished: false,
        }
    },
    methods: {
        changeFilterType(...args) {
            let filterType = -255

            if (args.length == 1) {
                filterType = args[0]
            } else if (args.length > 1) {
                filterType = args[1]
            }

            if (this.searchForm.filterType == filterType) {
                return
            }

            this.searchForm.filterType = filterType
            this.getOrder()
        },

        // onLoad() {
        //     // // 异步更新数据
        //     // // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        //     let pageSize = 10

        //     setTimeout(() => {
        //         this.page += 1
        //         for (let i = 0; i < 10; i++) {
        //             this.list.push(this.list.length + 1);
        //         }

        //         // 加载状态结束
        //         this.loading = false;

        //         // 数据全部加载完成
        //         if (this.page >= pageSize) {
        //             this.finished = true;
        //         }
        //         console.log('page', this.page)
        //     }, 1000);
        // },
        toDetail(id) {
            this.$router.push('/my/orderInfo?id=' + id + "&type=1")
        },
        toHome(url) {
            this.$router.push(url)
        },
        async getOrder() {

            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiGet('orders.list', this.searchForm)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            this.list = apiResult.list
        },
        handleScroll() {
            let innerHeight = this.$el.clientHeight;
            //屏幕尺寸高度
            let outerHeight = document.documentElement.clientHeight;
            //可滚动容器超出当前窗口显示范围的高度
            let scrollTop = document.documentElement.scrollTop;
            //避免切换时读取到异常高度
            if (scrollTop == 0) {
                innerHeight = 10000
            }
            //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
            console.log(innerHeight + " " + outerHeight + " " + scrollTop);
            if (this.isLoad) {
                console.log(1)
                if (innerHeight <= outerHeight + scrollTop) {
                    console.log("???到底了")
                    //此处添加自定义操作
                }
            }
        }
    },
    mounted() {
        // window.addEventListener("scroll", this.handleScroll);
    },
    created() {
        let query = this.$route.query
        this.searchForm.filterType = query.filterType || -255
        this.getOrder()
    }
}
</script>

<style lang="less">
.rd {
    .van-progress {
        width: 200px;
    }
}

.van-empty__image {
    width: 500px;
    height: 500px;
}
</style>
<style lang="less" scoped>
.page {
    .search {
        .van-search {
            padding-bottom: 0;
            padding-top: 0;
        }

        .van-search__content {
            border-radius: 10px;
        }
    }

    .tabs {
        width: 100%;
        height: 88px;
        z-index: 1;
        padding: 0 30px;
        box-sizing: border-box;
        background: #fff;

        .tabs-list {
            box-sizing: border-box;
            width: 33%;
            height: 88px;
            // border-bottom: 2px solid transparent;
            color: #333;
            position: relative;

            span {
                height: 78px;
                line-height: 88px;

                &.cur {
                    font-weight: bold;
                    font-size: 15px;
                    color: #376CFE;
                    // border-bottom-color: #fff;
                }
            }

            div {
                width: 40px;
                height: 4px;
                background: #376CFE;
                border-radius: 2px;
                position: absolute;
                bottom: 4px;
                left: 50%;
                margin-left: -20px;
            }

            // &.cur {
            //     color: #fff;
            //     border-bottom-color: #fff;
            // }
        }
    }

    .item {
        width: 690px;
        margin-left: 30px;
        margin-top: 30px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);

        .bd1 {
            border-radius: 20px;
            background: #fff;
            width: 690px;
            margin: 0 auto;
            border-radius: 12px;
            margin-bottom: 30px;
        }
    }

    .sc-item {
        // border-bottom: 1px solid #f8f8f8;
        padding: 30px 24px 0 24px;

        .header {
            padding-bottom: 20px;
            border-bottom: solid 1px #F9F5F5;
        }

        .rb {
            padding: 20px 0;
            border-bottom: solid 1px #F9F5F5;

            .list {
                line-height: 60px;

                .tit {
                    width: 150px;
                }

            }
        }

        .txt1 {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis !important;
        }
    }


    .ops {
        padding: 20px 24px;
        box-sizing: border-box;

        span {
            font-size: 16px;
            color: #5bb637;

            &.on {
                color: #e84115;
            }
        }

        .s1,
        .s2,
        .s3 {
            width: 170px;
            border-radius: 100px;
            // padding: 10rpx 0;
            font-size: 14px;
            margin-left: 20px;
            text-align: center;
            line-height: 60px;
            border: solid 1px #B5B5B5;
            color: #B5B5B5;
        }

        .s2 {
            background: #205CFF;
            border: solid 1px #205CFF;
            color: #fff;
        }

        .s3 {
            background: #D65E5E;
            border: solid 1px #D65E5E;
            color: #fff;
        }

    }
}
</style>